<template>
  <v-app :dark="dark">
    <v-navigation-drawer
      fixed
      clipped
      v-model="drawer"
      app
      temporary>
      <v-list>
        <v-list-tile
          value="true"
          v-for="(item, i) in menuItems"
          :key="i"
          router
          :to="item.link">
          <v-list-tile-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>


    <v-toolbar
      fixed
      clipped-left
      app>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <span class="headline font-weight-black font-italic">
        <router-link to="/" tag="span" style="cursor:pointer;">{{ dashboardHeading }}</router-link>
      </span>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <!-- <v-btn icon>
        <v-icon @click.stop="dark=!dark">invert_colors</v-icon>
      </v-btn> -->
    </v-toolbar>
    

    <v-content class="content-bg">

      <router-view></router-view>
     
    </v-content>


    <v-footer class="pl-4" fixed app>
    </v-footer>
  </v-app>
</template>

<script>


export default {
  name: 'App',
  components: {
    
  },
  data () {
    return {
      dark: true,
      drawer: false,
      dashboardHeading: 'Money4Cars'
    }
  },
  computed: {
    menuItems() {
      let menuItems = [
        //{ icon: 'bubble_chart', title: 'Sign Up', link: '/signup' },
        { icon: 'verified_user', title: 'Sign In', link: '/login' }
      ]
      if( this.userIsAuthenticated ){
        menuItems = [
            /*{ icon: 'supervisor_account', title: 'Home', link: '/'},
            { icon: 'room', title: 'About', link: '/about'},*/
            { icon: 'trending_up', title: 'Overview', link: '/' },
            { icon: 'alarm_on', title: 'Appointments', link: '/appointments' },
            { icon: 'directions_cars', title: 'Submissions', link: '/submissions' },
            { icon: 'account_circle', title: 'Profile', link: '/profile' },
            { icon: 'bubble_chart', title: 'Sign Out', link: '/logout' }
          ]
      }
      return menuItems
    },
    userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    }
  }
}
</script>

